import { render, staticRenderFns } from "./OptionList.vue?vue&type=template&id=c488ae58&scoped=true&"
import script from "./OptionList.vue?vue&type=script&lang=ts&"
export * from "./OptionList.vue?vue&type=script&lang=ts&"
import style0 from "./OptionList.vue?vue&type=style&index=0&id=c488ae58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c488ae58",
  null
  
)

export default component.exports